module.exports = __webpack_public_path__ + "static/media/RRD4-BG2.2d896bb4.jpg";